import React from 'react';

import PageContainer from '../../components/layout/page-container/PageContainer';
import { useTranslation } from 'react-i18next';
import AppTabs from '../../components/designe/app-tabs/AppTabs';
import { Paths } from '../../shared/paths';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useStyles } from './ModeratorDashboard.styles';
import theme from '../../styles/theme';
import { useAccess } from '../../hooks/useAccess';
import ExercisePublicRequests from './exercise-public-requests/ExercisePublicRequests';
import AllExercises from './all-exercises/AllExercises';
import Exercise from './exercise/Exercise';
import BugReports from './bug-reports/BugReports';
import PublicExercises from './public-exercises/PublicExercises';
import NewExercise from './new-exercise/NewExercise';
import Support from './support/Support';

const ModeratorDashboard = (props) => {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const { loading, access } = useAccess();
  const hasAccess = access?.adminPanels?.canViewModeratorPanel;
  if (!loading && !hasAccess) return <Navigate to={Paths.root} />;

  if (loading) {
    //handle it
    return null;
  }

  const viewAccess = {
    exercise: access?.exercisePostings?.canView ?? false,
    publicExerciseRequests: access?.exercisePostings?.canView ?? false,
    publicExercises: access?.exercises?.canView ?? false,
    allExercises: true,
    bugReports: access?.bugReports?.canView ?? false,
    support: access?.supportRequests?.canView ?? false,
    randomPosts: false,
    reviewPosts: false,
  };

  function getTabsConfig() {
    const tabsConfig = [];

    if (viewAccess.publicExerciseRequests) {
      tabsConfig.push({
        label: t('moderatorDashboard.publicExerciseRequests'),
        path: Paths.moderatorDashboard.publicExerciseRequests(),
      });
    }

    if (viewAccess.publicExercises) {
      tabsConfig.push({
        label: t('moderatorDashboard.publicExercises'),
        path: Paths.moderatorDashboard.publicExercises(),
      });
    }

    if (viewAccess.allExercises) {
      tabsConfig.push({
        label: t('moderatorDashboard.allExercises'),
        path: Paths.moderatorDashboard.allExercises(),
      });
    }

    if (viewAccess.bugReports) {
      tabsConfig.push({
        label: t('moderatorDashboard.bugReports'),
        path: Paths.moderatorDashboard.bugReports(),
      });
    }

    if (viewAccess.support) {
      tabsConfig.push({
        label: t('adminDashboard.support.tab'),
        path: Paths.moderatorDashboard.support(),
      });
    }

    if (viewAccess.randomPosts) {
      tabsConfig.push({
        label: t('moderatorDashboard.randomPosts'),
        path: Paths.moderatorDashboard.randomPosts(),
      });
    }

    if (viewAccess.reviewPosts) {
      tabsConfig.push({
        label: t('moderatorDashboard.toReviewPosts'),
        path: Paths.moderatorDashboard.reviewPosts(),
      });
    }

    return tabsConfig;
  }

  const tabsConfig = getTabsConfig();
  const firstTabPath = tabsConfig[0]?.path;

  return (
    <PageContainer title={t('moderatorDashboard.moderatorDashboard')}>
      <AppTabs config={tabsConfig} />
      <div className={classes.tabsContent}>
        <Routes>
          {viewAccess.publicExerciseRequests && (
            <Route
              path={Paths.moderatorDashboard.publicExerciseRequests(false)}
              element={<ExercisePublicRequests />}
            />
          )}
          {viewAccess.publicExercises && (
            <Route
              path={Paths.moderatorDashboard.publicExercises(false)}
              element={<PublicExercises />}
            />
          )}
          {viewAccess.allExercises && (
            <Route
              path={Paths.moderatorDashboard.allExercises(false)}
              element={<AllExercises />}
            />
          )}
          {viewAccess.bugReports && (
            <Route
              path={`${Paths.moderatorDashboard.bugReports(false)}/*`}
              element={<BugReports />}
            />
          )}
          {viewAccess.support && (
            <Route
              path={`${Paths.moderatorDashboard.support(false)}/*`}
              element={<Support />}
            />
          )}
          {viewAccess.reviewPosts && (
            <Route
              path={Paths.moderatorDashboard.reviewPosts(false)}
              element={<div>reviewPosts</div>}
            />
          )}
          {viewAccess.randomPosts && (
            <Route
              path={Paths.moderatorDashboard.randomPosts(false)}
              element={<div>randomPosts</div>}
            />
          )}
          {viewAccess.exercise && (
            <>
              <Route
                path={Paths.moderatorDashboard.exerciseNew(false)}
                element={<NewExercise />}
              />
              <Route
                path={Paths.moderatorDashboard.exerciseEdit(
                  ':exerciseId',
                  false,
                )}
                element={<NewExercise />}
              />
              <Route
                path={Paths.moderatorDashboard.exercise(':exerciseId', false)}
                element={<Exercise />}
              />
            </>
          )}
          <Route
            path={'/'}
            element={
              firstTabPath ? (
                <Navigate to={firstTabPath} replace />
              ) : (
                <Navigate to={Paths.root} replace />
              )
            }
          />
        </Routes>
      </div>
    </PageContainer>
  );
};

export default ModeratorDashboard;
